(function () {
  var hamburger = document.querySelector('.op-nav__hamburger');
  var drawer    = document.querySelector('.op-nav__drawer');
  var overlay   = document.querySelector('.op-nav__overlay');
  var closeBtn  = document.querySelector('.op-nav__drawer-close');

  if (!hamburger || !drawer) return;

  var drawerLinks = drawer.querySelectorAll('.op-nav__drawer-link');

  if (typeof gsap !== 'undefined') {
    gsap.set(drawerLinks, { opacity: 0, y: 24 });
  }

  function openDrawer() {
    document.body.classList.add('nav-open');
    hamburger.setAttribute('aria-expanded', 'true');
    if (typeof gsap !== 'undefined') {
      gsap.fromTo(
        drawerLinks,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.6, stagger: 0.08, delay: 0.25, ease: 'power3.out' }
      );
    }
  }

  function closeDrawer() {
    document.body.classList.remove('nav-open');
    hamburger.setAttribute('aria-expanded', 'false');
    if (typeof gsap !== 'undefined') {
      gsap.set(drawerLinks, { opacity: 0, y: 24 });
    }
  }

  hamburger.addEventListener('click', function () {
    if (document.body.classList.contains('nav-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
      closeDrawer();
    }
  });
})();
